/* Custom Header - V16 (extracted asset)
   Pairs with sections/custom-header.liquid and assets/custom-header.css.
   All store-specific values (locale routes, currency, popular searches) are
   read from data attributes on the [data-header] element, so this file
   contains no Liquid and caches across pages. */
(function(){
  'use strict';

  // Filled from data attributes in init()
  var shopCurrency = '';
  var searchUrl = '/search';
  var predictiveUrl = '/search/suggest';
  var rootUrl = '/';
  var popularTerms = [];
  var moneyFmt = null;
  var moneySample = '';
  var moneyParts = null;

  var CLOSE_DELAY = 300;
  var OPEN_DELAY = 90;
  var SEARCH_DELAY = 250;

  // Cached DOM references
  var dom = {};
  var state = {
    activeDd: null,
    closeTimer: null,
    openTimer: null,
    peekTimer: null,
    searchAbort: null,
    currentQuery: '',
    focusedIdx: -1,
    resultItems: [],
    scrollPos: 0
  };

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.from((c || document).querySelectorAll(s)); }

  function init() {
    // Cache all DOM elements
    dom.header = $('[data-header]');
    if (!dom.header) return;
    // Guard against re-running (Shopify theme editor re-injects the section markup)
    if (dom.header.dataset.headerInit) return;
    dom.header.dataset.headerInit = '1';

    // Store config from data attributes (locale-aware routes etc.)
    var cfg = dom.header.dataset;
    rootUrl = cfg.homeUrl || '/';
    searchUrl = cfg.searchUrl || '/search';
    predictiveUrl = cfg.predictiveUrl || '/search/suggest';
    shopCurrency = cfg.currency || '';
    // What Liquid's money filter prints for 111111 (1,111.11) in the cart currency,
    // so search prices match every Liquid-rendered price on the page.
    moneySample = cfg.moneySample || '';
    moneyParts = moneySample.match(/1([.,'\u2019 \u00a0\u202f]?)111(?:([.,])11)?/);
    try { popularTerms = JSON.parse(cfg.popular || '[]') || []; } catch(e) { popularTerms = []; }
    try { moneyFmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: shopCurrency }); } catch(e) { moneyFmt = null; }

    // Signal CSS that JS is ready - enables animated show/hide instead of display:none
    dom.header.classList.add('is-ready');

    dom.overlay = $('[data-overlay]');
    dom.announce = $('[data-announce]');
    dom.searchBar = $('[data-search-bar]');
    dom.searchInput = $('[data-search-input]');
    dom.searchClear = $('[data-search-clear]');
    dom.searchDropdown = $('[data-search-dropdown]');
    dom.searchResults = $('[data-search-results]');
    dom.searchToggle = $('[data-search-toggle]');
    dom.mobileMenu = $('[data-mobile-menu]');
    dom.mobileOverlay = $('[data-mobile-overlay]');
    dom.mobileToggle = $('[data-mobile-toggle]');
    dom.mobileSearchInput = $('[data-mobile-search-input]');
    dom.mobileSearchClear = $('[data-mobile-search-clear]');
    dom.langDropdown = $('[data-lang-dropdown]');
    dom.langToggle = $('[data-lang-toggle]');
    dom.mobileLangDropdown = $('[data-mobile-lang-dropdown]');
    dom.mobileLangToggle = $('[data-mobile-lang-toggle]');
    dom.localeInput = $('#locale-input');
    dom.langForm = $('#lang-form');

    // Cache dropdown triggers and their dropdowns
    dom.ddTriggers = {};
    dom.dropdowns = {};
    $$('[data-dd-trigger]').forEach(function(t) {
      var id = t.dataset.ddTrigger;
      dom.ddTriggers[id] = t;
      dom.dropdowns[id] = $('[data-dropdown="' + id + '"]');
    });

    // Restore announcement state (also done pre-paint by the inline script next to the markup)
    if (dom.announce) {
      try { if (sessionStorage.getItem(dom.announce.dataset.announceKey || 'announce_closed')) dom.announce.classList.add('is-hidden'); } catch(e) {}
    }

    // Single delegated click + keydown handlers. Routed through window-level
    // forwarders so a theme-editor section reload (which re-executes this script
    // against fresh markup) REPLACES the implementation instead of stacking a
    // second listener whose closure holds stale DOM references (symptom: mobile
    // accordions toggling twice per tap inside the editor).
    window.__chClick = handleClick;
    window.__chKey = handleEscape;
    if (!window.__chDelegated) {
      window.__chDelegated = true;
      document.addEventListener('click', function(e) { window.__chClick && window.__chClick(e); });
      document.addEventListener('keydown', function(e) { window.__chKey && window.__chKey(e); });
    }

    // Setup dropdown hover events
    setupDropdownHover();

    // Desktop language menu: tabbing past its last option left it open over
    // the page (only an outside click or Escape closed it).
    var langSelector = $('[data-lang-selector]');
    if (langSelector && dom.langDropdown) {
      langSelector.addEventListener('focusout', function(e) {
        var to = e.relatedTarget;
        if (to && !langSelector.contains(to) && dom.langDropdown.classList.contains('is-open')) closeLang();
      });
    }

    // Setup search
    if (dom.searchInput) {
      dom.searchInput.addEventListener('input', handleSearchInput);
      dom.searchInput.addEventListener('keydown', handleSearchKeydown);
    }

    // Save recent search on plain Enter form submit (desktop + mobile)
    var searchForm = dom.searchBar ? $('.search__form', dom.searchBar) : null;
    if (searchForm && dom.searchInput) {
      searchForm.addEventListener('submit', function() { saveRecent(dom.searchInput.value.trim()); });
    }
    var mobileSearchForm = $('.mobile-search__form');
    if (mobileSearchForm && dom.mobileSearchInput) {
      mobileSearchForm.addEventListener('submit', function() { saveRecent(dom.mobileSearchInput.value.trim()); });
    }

    // Mobile search clear
    if (dom.mobileSearchInput) {
      dom.mobileSearchInput.addEventListener('input', function() {
        dom.mobileSearchClear.hidden = !this.value.length;
      });
    }

    // Escape key is handled by the delegated keydown forwarder above.

    // Close mobile menu when viewport crosses desktop breakpoint
    var mql = window.matchMedia('(min-width: 769px)');
    function onBreakpoint(e) {
      if (e.matches && dom.mobileMenu && dom.mobileMenu.classList.contains('is-open')) closeMobile();
      // Crossing DOWN into mobile: the desktop search bar and nav dropdowns are
      // display:none'd by CSS, but their open state (overlay, body classes)
      // would otherwise survive the resize orphaned.
      if (!e.matches) {
        if (dom.header.classList.contains('search-active')) closeSearch();
        closeAllDropdowns();
      }
    }
    // MediaQueryList only gained addEventListener in Safari 14 — on iOS <=13 it
    // throws and would kill the rest of init() (cart badge, focus trap, swipe).
    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', onBreakpoint);
    else if (typeof mql.addListener === 'function') mql.addListener(onBreakpoint);

    // Sync overlay/solid class on Shopify AJAX navigation (locale-aware)
    var homeUrl = (rootUrl || '/').replace(/\/+$/, '');
    function syncOverlayMode() {
      var header = document.querySelector('[data-header]');
      if (!header) return;
      var path = window.location.pathname.replace(/\/+$/, '');
      var isHome = path === homeUrl;
      header.classList.toggle('custom-header--overlay', isHome);
      if (!isHome && !state.activeDd) header.classList.remove('is-solid');
    }
    document.addEventListener('shopify:section:load', syncOverlayMode);
    document.addEventListener('shopify:section:unload', syncOverlayMode);
    // Catch client-side routers (e.g. theme AJAX cart, InstantClick, Turbo, etc.)
    window.addEventListener('popstate', syncOverlayMode);
    // Observe pushState/replaceState for SPA-style navigation.
    // Patch once globally so editor section reloads don't stack wrappers.
    if (!window.__chHistoryPatched) {
      window.__chHistoryPatched = true;
      var origPush = history.pushState;
      var origReplace = history.replaceState;
      history.pushState = function() { origPush.apply(this, arguments); syncOverlayMode(); };
      history.replaceState = function() { origReplace.apply(this, arguments); syncOverlayMode(); };
    }

    // Keep the cart count + mini-cart fresh after AJAX add/change
    patchCartDetection();

    // Pages shown again by Back/Forward (from bfcache, or re-run from the HTTP
    // cache) or served from a prefetch (or its 10 s cache copy) carry the cart as
    // it was when that HTML was made. Check the live cart once; re-render only if
    // it differs. The layout's prefetch script leaves this check to the header.
    var navEntry = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    if (navEntry.type === 'back_forward' || navEntry.deliveryType === 'navigational-prefetch' || navEntry.deliveryType === 'cache') syncCartAfterRestore();
    // Routed through a window-level forwarder like __chClick, so an editor
    // section reload replaces the handler instead of stacking a stale one.
    window.__chRestore = function(e) {
      if (!e || !e.persisted) return;
      closeAllDropdowns(); // a mega menu open at navigation time stays open over the restored page
      syncCartAfterRestore();
    };
    if (!window.__chPageshow) {
      window.__chPageshow = true;
      window.addEventListener('pageshow', function(e) { window.__chRestore && window.__chRestore(e); });
    }
    // Leaving the page (it may go into the back/forward cache): a cart refresh
    // still pending or in flight from an add on this page must not pulse the
    // badge or peek the mini-cart when the page is shown again by Back. The
    // restore check above corrects the count quietly instead.
    window.__chHide = function() {
      cartRefreshEpoch++;
      clearTimeout(cartRefreshTimer);
    };
    if (!window.__chPagehide) {
      window.__chPagehide = true;
      window.addEventListener('pagehide', function(e) { window.__chHide && window.__chHide(e); });
    }

    // A mega-menu left open while the page scrolls detaches from the header on
    // the homepage (overlay header is position:absolute). Standard behavior:
    // put it away as soon as the user scrolls.
    window.addEventListener('scroll', function() {
      if (state.activeDd) closeAllDropdowns();
    }, { passive: true });

    // Theme editor: selecting a dropdown-card block should reveal the dropdown
    // it lives in, so editing cards is WYSIWYG instead of blind.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function(e) {
        var dd = e.target && e.target.closest && e.target.closest('.nav__dropdown');
        if (dd) openDropdown(dd.dataset.dropdown);
      });
      document.addEventListener('shopify:block:deselect', function(e) {
        var dd = e.target && e.target.closest && e.target.closest('.nav__dropdown');
        if (dd) closeDropdown(dd.dataset.dropdown);
      });
    }

    // Touch/press on the menu button: start the menu thumbnails a beat before
    // the click that opens it.
    if (dom.mobileToggle) dom.mobileToggle.addEventListener('pointerdown', hydrateMobileImages, { passive: true });

    // Trap focus inside the mobile menu while it is open
    if (dom.mobileMenu) {
      dom.mobileMenu.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab' || !dom.mobileMenu.classList.contains('is-open')) return;
        // Controls under visibility:hidden (the closed language list, collapsed
        // accordion sub-links) keep their boxes but cannot take focus. Counting one
        // as `last` let Tab fall out of the menu into the page behind it and made
        // Shift+Tab on the first item do nothing.
        var f = $$('a[href],button:not([disabled]),input', dom.mobileMenu).filter(function(el) {
          return el.tabIndex !== -1 && (el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden';
        });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    // Mobile swipe to close (swipe down). Only when the touch started with the
    // menu scrolled to the top; otherwise a downward drag is the user scrolling
    // back up through a long menu, not a dismiss gesture.
    if (dom.mobileMenu) {
      var touchStartY = 0;
      var touchStartAtTop = true;
      var scrolledToTop = function(el) {
        for (; el && el !== dom.mobileMenu.parentNode; el = el.parentElement) {
          if (el.scrollTop > 0) return false;
        }
        return true;
      };
      dom.mobileMenu.addEventListener('touchstart', function(e) {
        touchStartY = e.changedTouches[0].screenY;
        touchStartAtTop = scrolledToTop(e.target);
      }, { passive: true });
      dom.mobileMenu.addEventListener('touchend', function(e) {
        var deltaY = e.changedTouches[0].screenY - touchStartY;
        if (deltaY > 100 && touchStartAtTop) closeMobile(); // Swipe down to close
      }, { passive: true });
    }
  }

  function handleClick(e) {
    var t = e.target;

    // Announcement close
    if (t.closest('[data-announce-close]')) {
      dom.announce && dom.announce.classList.add('is-hidden');
      try { sessionStorage.setItem((dom.announce && dom.announce.dataset.announceKey) || 'announce_closed', '1'); } catch(ex) {}
      return;
    }

    // Search toggle
    if (t.closest('[data-search-toggle]')) {
      dom.header.classList.contains('search-active') ? closeSearch() : openSearch();
      return;
    }

    // Search close
    if (t.closest('[data-search-close]')) {
      closeSearch();
      return;
    }

    // Search clear
    if (t.closest('[data-search-clear]')) {
      // Cancel the pending or in-flight request for the cleared text, or its
      // results land under the now empty input.
      clearTimeout(searchTimeout);
      if (state.searchAbort) { state.searchAbort.abort(); state.searchAbort = null; }
      state.currentQuery = '';
      dom.searchInput.value = '';
      dom.searchClear.hidden = true;
      dom.searchInput.focus();
      hideSearchDropdown();
      showSuggestions();
      return;
    }

    // Mobile toggle
    if (t.closest('[data-mobile-toggle]')) {
      dom.mobileMenu && dom.mobileMenu.classList.contains('is-open') ? closeMobile() : openMobile();
      return;
    }

    // Mobile close
    if (t.closest('[data-mobile-close]') || t.closest('[data-mobile-overlay]')) {
      closeMobile();
      return;
    }

    // Mobile search clear
    if (t.closest('[data-mobile-search-clear]')) {
      dom.mobileSearchInput.value = '';
      dom.mobileSearchClear.hidden = true;
      dom.mobileSearchInput.focus();
      return;
    }

    // Mobile accordion
    var accBtn = t.closest('[data-mobile-acc]');
    if (accBtn) {
      var id = accBtn.dataset.mobileAcc;
      var exp = accBtn.getAttribute('aria-expanded') === 'true';

      // Close others
      $$('[data-mobile-acc]').forEach(function(b) {
        if (b !== accBtn) {
          b.setAttribute('aria-expanded', 'false');
          var c = $('[data-mobile-acc-content="' + b.dataset.mobileAcc + '"]');
          if (c) { c.classList.remove('is-open'); c.setAttribute('aria-hidden', 'true'); }
        }
      });

      accBtn.setAttribute('aria-expanded', !exp);
      var content = $('[data-mobile-acc-content="' + id + '"]');
      if (content) {
        if (!exp) content.style.setProperty('--acc-height', content.scrollHeight + 'px');
        content.classList.toggle('is-open', !exp);
        content.setAttribute('aria-hidden', exp);
      }
      return;
    }

    // Language toggle (desktop)
    if (t.closest('[data-lang-toggle]')) {
      e.stopPropagation();
      if (dom.langDropdown) {
        var langOpen = dom.langDropdown.classList.toggle('is-open');
        dom.langDropdown.setAttribute('aria-hidden', !langOpen);
        dom.langToggle && dom.langToggle.setAttribute('aria-expanded', langOpen);
      }
      return;
    }

    // Language option
    var langOpt = t.closest('[data-lang-code]');
    if (langOpt) {
      var code = langOpt.dataset.langCode;
      if (dom.localeInput && dom.langForm) {
        dom.localeInput.value = code;
        dom.langForm.submit();
      }
      return;
    }

    // Mobile language toggle
    if (t.closest('[data-mobile-lang-toggle]')) {
      e.stopPropagation();
      if (dom.mobileLangDropdown) {
        var mLangOpen = dom.mobileLangDropdown.classList.toggle('is-open');
        dom.mobileLangDropdown.setAttribute('aria-hidden', !mLangOpen);
        dom.mobileLangToggle && dom.mobileLangToggle.setAttribute('aria-expanded', mLangOpen);
      }
      return;
    }

    // Search suggestion
    var suggBtn = t.closest('[data-term]');
    if (suggBtn) {
      dom.searchInput.value = suggBtn.dataset.term;
      dom.searchClear.hidden = false;
      dom.searchInput.dispatchEvent(new Event('input'));
      return;
    }

    // Save recent search on result click
    if (t.closest('.search__result-item') && state.currentQuery) {
      saveRecent(state.currentQuery);
    }

    // Overlay click
    if (t.closest('[data-overlay]')) {
      closeAllDropdowns();
      closeSearch();
      return;
    }

    // Click outside search
    if (dom.header.classList.contains('search-active')) {
      if (!t.closest('[data-search-bar]') && !t.closest('[data-search-dropdown]') && !t.closest('[data-search-toggle]')) {
        closeSearch();
      }
    }

    // Close language dropdowns on outside click
    if (!t.closest('[data-lang-selector]') && dom.langDropdown && dom.langDropdown.classList.contains('is-open')) closeLang();
    if (!t.closest('[data-mobile-lang]') && dom.mobileLangDropdown && dom.mobileLangDropdown.classList.contains('is-open')) {
      dom.mobileLangDropdown.classList.remove('is-open');
      dom.mobileLangDropdown.setAttribute('aria-hidden', 'true');
      dom.mobileLangToggle && dom.mobileLangToggle.setAttribute('aria-expanded', 'false');
    }
  }

  // Start loading a dropdown's card images. Called on hover intent so the
  // images are already in flight before the dropdown becomes visible.
  function hydrateImages(id) {
    var dd = dom.dropdowns[id];
    if (!dd || dd.dataset.hydrated) return;
    dd.dataset.hydrated = '1';
    $$('img[data-src]', dd).forEach(function(img) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  function setupDropdownHover() {
    Object.keys(dom.ddTriggers).forEach(function(id) {
      var trigger = dom.ddTriggers[id];
      var dd = dom.dropdowns[id];
      var parent = trigger.closest('.nav__item');

      parent.addEventListener('mouseenter', function() {
        if (state.closeTimer) { clearTimeout(state.closeTimer); state.closeTimer = null; }
        if (state.openTimer) { clearTimeout(state.openTimer); state.openTimer = null; }
        // Preload images immediately so they're ready when the drawer opens
        hydrateImages(id);
        // Hover intent: small delay before opening so crossing the nav doesn't
        // flash dropdowns. Switch instantly if one is already open.
        var delay = state.activeDd ? 0 : OPEN_DELAY;
        state.openTimer = setTimeout(function() { state.openTimer = null; openDropdown(id); }, delay);
      });
      parent.addEventListener('mouseleave', function(e) {
        if (state.openTimer) { clearTimeout(state.openTimer); state.openTimer = null; }
        if (dd && dd.contains(e.relatedTarget)) return;
        scheduleCloseDropdown(id);
      });

      if (dd) {
        dd.addEventListener('mouseenter', function() {
          if (state.closeTimer) { clearTimeout(state.closeTimer); state.closeTimer = null; }
        });
        dd.addEventListener('mouseleave', function(e) {
          if (parent && parent.contains(e.relatedTarget)) return;
          scheduleCloseDropdown(id);
        });
        // Tabbing past the last card should put the menu away, not leave the
        // panel + overlay floating over the page.
        dd.addEventListener('focusout', function(e) {
          var to = e.relatedTarget;
          if (state.activeDd === id && to && !dd.contains(to) && !parent.contains(to)) closeDropdown(id);
        });
        // The panel is rendered after .header__inner, so native Tab order runs
        // from its last card into <main> and Shift+Tab from its first card onto
        // the language toggle. Step through it as if it followed the trigger.
        dd.addEventListener('keydown', function(e) {
          if (e.key !== 'Tab' || state.activeDd !== id) return;
          var items = panelItems(dd);
          if (!items.length) return;
          if (e.shiftKey && document.activeElement === items[0]) {
            e.preventDefault();
            trigger.focus();
          } else if (!e.shiftKey && document.activeElement === items[items.length - 1]) {
            var next = nextTopLevel(trigger);
            if (!next) return; // nothing after it: native Tab, focusout closes the panel
            e.preventDefault();
            closeDropdown(id);
            next.focus();
          }
        });
      }

      // Focus leaving the trigger for anything but its own panel (e.g. Shift+Tab
      // back along the nav) puts the panel away, like tabbing out of the panel does.
      trigger.addEventListener('focusout', function(e) {
        var to = e.relatedTarget;
        if (state.activeDd === id && to && !(dd && dd.contains(to)) && !parent.contains(to)) closeDropdown(id);
      });

      // Touch devices wide enough for the desktop nav (e.g. iPad landscape) get
      // an emulated mouseenter on first tap, but had no way to close from the
      // trigger. Mouse users keep hover behavior untouched.
      trigger.addEventListener('click', function() {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          if (window.matchMedia('(hover:none)').matches) closeDropdown(id);
        } else {
          openDropdown(id);
        }
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (trigger.getAttribute('aria-expanded') === 'true') {
            closeDropdown(id);
          } else {
            openDropdown(id);
            // Keyboard path: move focus into the panel so Tab reaches the cards
            // immediately (they sit far from the trigger in DOM order).
            // preventScroll: a focus-triggered scroll would fire the
            // close-on-scroll handler and immediately dismiss the panel.
            var first = panelItems(dd)[0];
            if (first) { try { first.focus({ preventScroll: true }); } catch(err) { first.focus(); } }
          }
        } else if (e.key === 'Escape') {
          closeDropdown(id);
          trigger.focus();
        } else if (e.key === 'Tab' && !e.shiftKey && trigger.getAttribute('aria-expanded') === 'true') {
          // Panel already open (clicked, or reached by Shift+Tab from its first
          // card): Tab goes into it instead of skipping to the next nav item.
          var firstItem = panelItems(dd)[0];
          if (firstItem) {
            e.preventDefault();
            try { firstItem.focus({ preventScroll: true }); } catch(err) { firstItem.focus(); }
          }
        }
      });
    });
  }

  // The top-level stop that follows a dropdown trigger: the next visible nav
  // link, else the first visible header action (search, account, cart...).
  // Nav items hidden at narrower widths (hide priority) are display:none.
  function nextTopLevel(trigger) {
    var stops = $$('.nav__list .nav__link, .header__actions .action-btn', dom.header).filter(function(el) {
      return el.tabIndex !== -1 && (el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
    var i = stops.indexOf(trigger);
    return i === -1 ? null : stops[i + 1] || null;
  }

  // The panel's rendered links/buttons. Restock Rocket can inject a "Notify me"
  // button next to a product card (display:none via custom-header.css); counted
  // as the last item, it let Tab off the real last card fall through to <main>.
  function panelItems(dd) {
    return dd ? $$('a,button', dd).filter(function(el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    }) : [];
  }

  function openDropdown(id) {
    closeSearch();
    if (state.closeTimer) { clearTimeout(state.closeTimer); state.closeTimer = null; }
    if (state.activeDd && state.activeDd !== id) closeDropdown(state.activeDd);

    var trigger = dom.ddTriggers[id];
    var dd = dom.dropdowns[id];
    if (trigger && dd) {
      trigger.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-active');
      dd.setAttribute('aria-hidden', 'false');
      hydrateImages(id); // covers the keyboard path; no-op if hover already did it
      $$('a,button', dd).forEach(function(el) { el.tabIndex = 0; });
      dom.overlay.classList.add('is-active');
      dom.header.classList.add('is-solid');
      state.activeDd = id;
    }
  }

  function closeDropdown(id) {
    var trigger = dom.ddTriggers[id];
    var dd = dom.dropdowns[id];
    if (trigger && dd) {
      trigger.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-active');
      dd.setAttribute('aria-hidden', 'true');
      $$('a,button', dd).forEach(function(el) { el.tabIndex = -1; });
      dom.overlay.classList.remove('is-active');
      // Keep the solid bg if the search bar is still using it (mirror closeSearch's guard).
      if (!dom.header.classList.contains('search-active')) dom.header.classList.remove('is-solid');
      if (state.activeDd === id) state.activeDd = null;
    }
  }

  function scheduleCloseDropdown(id) {
    state.closeTimer = setTimeout(function() { closeDropdown(id); }, CLOSE_DELAY);
  }

  function closeAllDropdowns() {
    if (state.openTimer) { clearTimeout(state.openTimer); state.openTimer = null; }
    if (state.activeDd) closeDropdown(state.activeDd);
  }

  // Search functions
  function openSearch() {
    closeAllDropdowns();
    dom.header.classList.add('search-active', 'is-solid');
    dom.searchBar.setAttribute('aria-hidden', 'false');
    dom.searchInput.tabIndex = 0;
    dom.searchToggle && dom.searchToggle.setAttribute('aria-expanded', 'true');
    if (state.searchFocusTimer) clearTimeout(state.searchFocusTimer);
    state.searchFocusTimer = setTimeout(function() {
      state.searchFocusTimer = null;
      if (!dom.header.classList.contains('search-active')) return; // dismissed during the delay — don't re-open
      dom.searchInput.focus();
      showSuggestions();
    }, 300);
  }

  function closeSearch() {
    clearTimeout(searchTimeout); // a debounced suggest request must not fire after closing
    if (state.searchFocusTimer) { clearTimeout(state.searchFocusTimer); state.searchFocusTimer = null; }
    if (state.searchAbort) { state.searchAbort.abort(); state.searchAbort = null; }
    dom.header.classList.remove('search-active');
    if (!state.activeDd) dom.header.classList.remove('is-solid');
    dom.searchDropdown.classList.remove('is-active');
    dom.searchDropdown.setAttribute('aria-hidden', 'true');
    dom.searchBar.setAttribute('aria-hidden', 'true');
    dom.searchInput.tabIndex = -1;
    dom.searchToggle && dom.searchToggle.setAttribute('aria-expanded', 'false');
    dom.overlay.classList.remove('is-active');
    dom.searchInput.value = '';
    dom.searchClear.hidden = true;
    dom.searchResults.innerHTML = '';
    state.currentQuery = '';
    state.focusedIdx = -1;
    state.resultItems = [];
  }

  function showSearchDropdown() {
    dom.searchDropdown.classList.add('is-active');
    dom.searchDropdown.setAttribute('aria-hidden', 'false');
    dom.overlay.classList.add('is-active');
  }

  function hideSearchDropdown() {
    dom.searchDropdown.classList.remove('is-active');
    dom.searchDropdown.setAttribute('aria-hidden', 'true');
    dom.overlay.classList.remove('is-active');
    state.focusedIdx = -1;
    state.resultItems = [];
  }

  function getRecent() {
    try { return JSON.parse(localStorage.getItem('recent_searches')) || []; } catch(e) { return []; }
  }

  function saveRecent(q) {
    if (!q || q.length < 2) return;
    try {
      var r = getRecent().filter(function(s) { return s.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q);
      localStorage.setItem('recent_searches', JSON.stringify(r.slice(0, 5)));
    } catch(e) {}
  }

  function showSuggestions() {
    var recent = getRecent();
    var popular = popularTerms;
    if (!recent.length && !popular.length) return;

    var html = '<div class="search__suggestions">';
    if (recent.length) {
      html += '<div class="search__suggestion-group"><h4 class="search__suggestion-title">Recent</h4><div class="search__suggestion-items">' +
        recent.map(function(t) {
          return '<button type="button" class="search__suggestion-item" data-term="' + esc(t) + '"><svg class="icon icon--sm"><use href="#icon-clock"/></svg>' + esc(t) + '</button>';
        }).join('') + '</div></div>';
    }
    html += '<div class="search__suggestion-group"><h4 class="search__suggestion-title">Popular</h4><div class="search__suggestion-items">' +
      popular.map(function(t) {
        return '<button type="button" class="search__suggestion-item" data-term="' + esc(t) + '"><svg class="icon icon--sm"><use href="#icon-search"/></svg>' + esc(t) + '</button>';
      }).join('') + '</div></div></div>';

    dom.searchResults.innerHTML = html;
    showSearchDropdown();
  }

  var searchTimeout;
  function handleSearchInput(e) {
    var q = e.target.value.trim();
    state.currentQuery = q;
    // Old results are replaced below; a highlight on them must not survive.
    state.focusedIdx = -1;
    state.resultItems = [];
    dom.searchClear.hidden = !q.length;

    if (searchTimeout) clearTimeout(searchTimeout);
    if (state.searchAbort) { state.searchAbort.abort(); state.searchAbort = null; }

    if (q.length < 2) {
      if (q.length === 0) showSuggestions();
      else hideSearchDropdown();
      return;
    }

    dom.searchResults.innerHTML = skeleton();
    showSearchDropdown();
    searchTimeout = setTimeout(function() { fetchResults(q); }, SEARCH_DELAY);
  }

  function handleSearchKeydown(e) {
    if (!dom.searchDropdown.classList.contains('is-active')) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      state.focusedIdx = Math.min(state.focusedIdx + 1, state.resultItems.length - 1);
      updateFocus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      state.focusedIdx = Math.max(state.focusedIdx - 1, -1);
      updateFocus();
    } else if (e.key === 'Enter' && state.focusedIdx >= 0 && state.resultItems[state.focusedIdx]) {
      e.preventDefault();
      saveRecent(state.currentQuery);
      state.resultItems[state.focusedIdx].click();
    }
  }

  function updateFocus() {
    state.resultItems.forEach(function(item, i) {
      item.classList.toggle('is-focused', i === state.focusedIdx);
      if (i === state.focusedIdx) item.scrollIntoView({ block: 'nearest' });
    });
  }

  function skeleton() {
    return '<div class="search__results-skeleton">' + [1,2,3,4,5,6].map(function() {
      return '<div class="skeleton-card"><div class="skeleton-image"></div><div class="skeleton-text"><div class="skeleton-line skeleton-line--medium"></div><div class="skeleton-line skeleton-line--short"></div></div></div>';
    }).join('') + '</div>';
  }

  function fetchResults(q) {
    state.searchAbort = new AbortController();

    fetch(predictiveUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=9&resources[options][fields]=title,tag,variants.title,product_type,vendor', {
      signal: state.searchAbort.signal
    })
    .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function(data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (q === state.currentQuery) renderResults(products, q);
    })
    .catch(function(err) {
      if (err.name !== 'AbortError') {
        dom.searchResults.innerHTML = '<div class="search__results-empty"><p>Search unavailable</p></div>';
        state.focusedIdx = -1;
        state.resultItems = [];
      }
    });
  }

  function renderResults(products, q) {
    if (!products.length) {
      dom.searchResults.innerHTML = '<div class="search__results-empty"><svg class="icon icon--xl" style="color:#444;margin-bottom:1rem"><use href="#icon-search"/></svg><p class="search__results-empty-title">No results</p><p class="search__results-empty-text">Try different keywords</p></div>';
      state.focusedIdx = -1;
      state.resultItems = [];
      return;
    }

    var html = '<div class="search__results-header"><span class="search__results-count">' + products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for "' + esc(q) + '"</span><a href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last" class="search__results-view-all">View all<svg class="icon icon--sm"><use href="#icon-arrow"/></svg></a></div><div class="search__results-grid">';

    products.forEach(function(p, i) {
      var img = p.image ? p.image.replace(/(\.[^.]+)$/, '_180x180$1') : '';
      var price = p.price ? formatMoney(parseFloat(p.price)) : '';
      var type = p.product_type || '';
      var title = highlight(p.title, q);
      html += '<a href="' + p.url + '" class="search__result-item" data-result-index="' + i + '">' +
        (img ? '<img src="' + img + '" alt="" class="search__result-image" loading="lazy" decoding="async" width="90" height="90">' : '<div class="search__result-image"></div>') +
        '<div class="search__result-info"><p class="search__result-title">' + title + '</p>' +
        (type ? '<p class="search__result-meta">' + esc(type) + '</p>' : '') +
        (price ? '<p class="search__result-price">' + price + '</p>' : '') +
        '</div></a>';
    });

    html += '</div>';
    dom.searchResults.innerHTML = html;
    state.focusedIdx = -1;
    state.resultItems = $$('.search__result-item', dom.searchResults);
  }

  function highlight(text, q) {
    // Literal, case-insensitive substring highlight done on the raw text, then
    // escaped per segment. Avoids regex special-char issues and never marks
    // inside HTML entities (e.g. the "amp" in "R&amp;B").
    if (!q) return esc(text);
    var lower = text.toLowerCase();
    var ql = q.toLowerCase();
    var out = '';
    var i = 0, idx;
    while ((idx = lower.indexOf(ql, i)) !== -1) {
      out += esc(text.slice(i, idx)) + '<mark>' + esc(text.slice(idx, idx + q.length)) + '</mark>';
      i = idx + q.length;
    }
    return out + esc(text.slice(i));
  }

  var escEl = document.createElement('div');
  // textContent->innerHTML escapes <>& but NOT quotes; we inject esc() output
  // into attribute values (data-term="..."), so quotes must be escaped too.
  function esc(t) { escEl.textContent = t; return escEl.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }

  function formatMoney(amount) {
    if (moneyParts && isFinite(amount)) {
      var dec = moneyParts[2] || '';
      var parts = amount.toFixed(dec ? 2 : 0).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyParts[1]);
      return moneySample.replace(moneyParts[0], whole + (dec ? dec + parts[1] : ''));
    }
    return moneyFmt ? moneyFmt.format(amount) : shopCurrency + ' ' + amount.toFixed(2);
  }


  // Mobile menu
  // Thumbnails in the closed menu are emitted as data-src so they do not
  // download on every page view (the off-screen menu sits inside the browser's
  // lazy-load margin). Start them on first intent to open the menu.
  function hydrateMobileImages() {
    if (!dom.mobileMenu || dom.mobileMenu.dataset.hydrated) return;
    dom.mobileMenu.dataset.hydrated = '1';
    $$('img[data-src]', dom.mobileMenu).forEach(function(img) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  function openMobile() {
    hydrateMobileImages();
    state.scrollPos = window.pageYOffset;
    document.body.classList.add('mobile-menu-open');
    document.body.style.top = '-' + state.scrollPos + 'px';
    dom.mobileMenu.classList.add('is-open');
    dom.mobileMenu.setAttribute('aria-hidden', 'false');
    dom.mobileMenu.inert = false;
    $$('a,button,input', dom.mobileMenu).forEach(function(el) { el.tabIndex = 0; });
    dom.mobileOverlay.classList.add('is-active');
    dom.mobileToggle.setAttribute('aria-expanded', 'true');
    setTimeout(function() { var f = $('button,a,input', dom.mobileMenu); if (f) f.focus(); }, 100);
  }

  function closeMobile() {
    document.body.classList.remove('mobile-menu-open');
    document.body.style.top = '';
    window.scrollTo(0, state.scrollPos);
    dom.mobileMenu.classList.remove('is-open');
    dom.mobileMenu.setAttribute('aria-hidden', 'true');
    dom.mobileMenu.inert = true;
    $$('a,button,input', dom.mobileMenu).forEach(function(el) { el.tabIndex = -1; });
    dom.mobileOverlay.classList.remove('is-active');
    dom.mobileToggle.setAttribute('aria-expanded', 'false');

    // Reset accordions
    $$('[data-mobile-acc]').forEach(function(acc) {
      acc.setAttribute('aria-expanded', 'false');
      var c = $('[data-mobile-acc-content="' + acc.dataset.mobileAcc + '"]');
      if (c) { c.classList.remove('is-open'); c.setAttribute('aria-hidden', 'true'); }
    });

    // Close language dropdown
    if (dom.mobileLangDropdown) {
      dom.mobileLangDropdown.classList.remove('is-open');
      dom.mobileLangDropdown.setAttribute('aria-hidden', 'true');
      dom.mobileLangToggle && dom.mobileLangToggle.setAttribute('aria-expanded', 'false');
    }
  }

  function handleEscape(e) {
    if (e.key !== 'Escape') return;

    // Close an open nav dropdown regardless of where focus is (the trigger's own
    // keydown handler only covers Escape while the trigger itself is focused).
    if (state.activeDd) {
      var ddTrigger = dom.ddTriggers[state.activeDd];
      closeAllDropdowns();
      ddTrigger && ddTrigger.focus();
    }
    if (dom.header.classList.contains('search-active')) {
      closeSearch();
      dom.searchToggle && dom.searchToggle.focus();
    }
    if (dom.mobileMenu && dom.mobileMenu.classList.contains('is-open')) {
      closeMobile();
      dom.mobileToggle.focus();
    }
    if (dom.langDropdown && dom.langDropdown.classList.contains('is-open')) {
      closeLang();
      dom.langToggle && dom.langToggle.focus();
    }
  }

  function closeLang() {
    dom.langDropdown.classList.remove('is-open');
    dom.langDropdown.setAttribute('aria-hidden', 'true');
    dom.langToggle && dom.langToggle.setAttribute('aria-expanded', 'false');
  }

  // ---- Cart refresh (keeps count + mini-cart current after AJAX add/change) ----
  var cartRefreshTimer;
  var cartRefreshEpoch = 0; // bumped on pagehide; a refresh started before it stays quiet
  function scheduleCartRefresh() {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(function() { refreshCart(); }, 350);
  }
  function cartAddedFeedback(header) {
    // Pulse the badge
    var badge = header.querySelector('[data-cart-count]');
    if (badge) {
      badge.classList.remove('is-pulsing');
      void badge.offsetWidth; // force reflow so the animation can restart
      badge.classList.add('is-pulsing');
    }
    // Briefly show the mini-cart on pointer devices so the add is acknowledged
    var mini = header.querySelector('[data-mini-cart]');
    if (mini && window.matchMedia('(hover:hover)').matches) {
      mini.classList.add('is-peek');
      clearTimeout(state.peekTimer);
      state.peekTimer = setTimeout(function() { mini.classList.remove('is-peek'); }, 2500);
    }
  }
  // quiet: update silently (no badge pulse, no mini-cart peek). Used after a
  // history restore, where nothing was just added on this page.
  function refreshCart(quiet) {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var sid = header.getAttribute('data-section-id');
    if (!sid) return;
    var epoch = cartRefreshEpoch;
    // cache: 'no-cache' (here and in syncCartAfterRestore): a page shown by
    // Back/Forward makes its requests in "use any cached copy" mode, and these
    // responses carry no Cache-Control, so a stale cart could come back.
    fetch(rootUrl + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin', cache: 'no-cache' })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nc = doc.querySelector('[data-cart-count]');
        var cc = header.querySelector('[data-cart-count]');
        var oldCount = cc ? parseInt(cc.textContent, 10) || 0 : 0;
        var newCount = nc ? parseInt(nc.textContent, 10) || 0 : 0;
        if (nc && cc) {
          cc.textContent = nc.textContent.trim();
          if (nc.hasAttribute('data-cart-sig')) cc.setAttribute('data-cart-sig', nc.getAttribute('data-cart-sig'));
        }
        var nm = doc.querySelector('[data-mini-cart] .mini-cart__inner');
        var cm = header.querySelector('[data-mini-cart] .mini-cart__inner');
        if (nm && cm) cm.innerHTML = nm.innerHTML;
        if (!quiet && epoch === cartRefreshEpoch && newCount > oldCount) cartAddedFeedback(header);
      })
      .catch(function() {});
  }
  // data-cart-sig on the badge is "item_count:total_price" (raw Liquid cart,
  // hidden add-on lines included), the same two fields /cart.js returns.
  function syncCartAfterRestore() {
    var cc = document.querySelector('[data-header] [data-cart-count]');
    if (!cc || !window.fetch) return;
    var url = ((window.routes && window.routes.cart_url) || rootUrl.replace(/\/?$/, '/') + 'cart') + '.js';
    fetch(url, { credentials: 'same-origin', cache: 'no-cache', headers: { Accept: 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function(c) {
        var cur = document.querySelector('[data-header] [data-cart-count]');
        if (cur && c && (c.item_count + ':' + c.total_price) !== cur.getAttribute('data-cart-sig')) refreshCart(true);
      })
      .catch(function() {});
  }
  function patchCartDetection() {
    if (window.__chCartPatched) return;
    window.__chCartPatched = true;
    var rx = /\/cart\/(add|change|update|clear)/;

    // Intercept fetch-based cart mutations
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function() {
        var u = arguments[0];
        if (u && typeof u === 'object') u = u.url || u.href; // Request or URL object
        var ret = origFetch.apply(this, arguments);
        try {
          if (typeof u === 'string' && rx.test(u) && ret && ret.then) {
            ret.then(function() { scheduleCartRefresh(); }, function() {});
          }
        } catch(e) {}
        return ret;
      };
    }

    // Intercept XHR-based cart mutations
    try {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(m, u) { this.__chUrl = u; return origOpen.apply(this, arguments); };
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function() {
        try {
          if (this.__chUrl && rx.test(this.__chUrl)) {
            this.addEventListener('load', function() { scheduleCartRefresh(); });
          }
        } catch(e) {}
        return origSend.apply(this, arguments);
      };
    } catch(e) {}

    // Fallback: common theme cart events
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(function(ev) {
      document.addEventListener(ev, scheduleCartRefresh);
    });
  }

  // ---- Escape closes the mini-cart preview ----
  // The popup opens on hover and on :focus-within (keyboard). Escape is the
  // standard way out; without it, keyboard users are stuck until they tab
  // through the whole popup. The is-escaped class overrides both open
  // conditions and clears when the pointer leaves or focus exits the wrap,
  // so the next hover/focus opens it again.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var wrap = document.querySelector('.header__cart-wrap');
    var mini = wrap && wrap.querySelector('[data-mini-cart]');
    if (!wrap || !mini) return;
    if (getComputedStyle(mini).visibility !== 'visible') return;
    mini.classList.remove('is-peek');
    mini.classList.add('is-escaped');
    if (wrap.contains(document.activeElement)) {
      var trigger = wrap.querySelector('a, button');
      if (trigger) trigger.focus();
    }
    var onLeave = function(ev) {
      if (ev.type === 'focusout' && ev.relatedTarget && wrap.contains(ev.relatedTarget)) return;
      mini.classList.remove('is-escaped');
      wrap.removeEventListener('mouseleave', onLeave);
      wrap.removeEventListener('focusout', onLeave);
    };
    wrap.addEventListener('mouseleave', onLeave);
    wrap.addEventListener('focusout', onLeave);
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
